import { staticTitles, customizableTitles } from '../constants/default-copy';
import get from 'lodash-es/get';

/**
 * @param campaign {object}
 * @param key {string}
 * @return {string}
 */
export function getCustomizableTitle(campaign, key) {
    const title = get(campaign, `customization.${key}`, null);

    return title !== null ? title : get(customizableTitles, key);
}

/**
 * @param stepAlias {string}
 * @return {string}
 */
export function getStaticTitle(stepAlias) {
    if (Object.prototype.hasOwnProperty.call(staticTitles, stepAlias)) {
        return staticTitles[stepAlias];
    }

    return 'UNDEFINED';
}

/**
 * @param campaign {object}
 * @param key {string}
 * @param defaultText {string}
 * @return {string}
 */
export function getProposalStepOverview(campaign, key, defaultText) {
    const overview = get(campaign, `customization.${key}`, null);

    return overview !== null ? overview : defaultText;
}
